module.exports = __webpack_public_path__ + "img/HYU.65532742.png";